<template>
  <div class="container">
    <!-- content(s) -->
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'" ref="header"></Header>
    <div id="content" class="rental" style="padding-bottom: 72px">
      <div class="progress" role="img" aria-label="총 3단계 중 1단계 세이프키발급 진행중">
        <ol aria-hidden="true">
          <li class="on"><span>동의 및 본인인증</span></li>
          <li><span>결제정보입력</span></li>
          <li><span>계약서작성</span></li>
        </ol>
      </div>

      <section class="hr">
        <div class="titArea">
          <h2 class="titH4">본인인증</h2>
        </div>
        <div class="formArea">
          <span class="label">이름</span>
          <div class="iptWrap">
            <ValidationProvider name="이름" rules="required" v-slot="{ errors }">
              <input type="text" id="ipt4" class="ipt uiAct" title="이름 입력" value="" v-model="customerName" />
            </ValidationProvider>
            <button class="btnIco_del" tabindex="-1">
              <span class="blind">해당 필드 입력값 삭제</span>
            </button>
          </div>

          <span class="label">생년월일</span>
          <div class="setBirth type2">
            <input
              type="tel"
              class="ipt"
              maxlength="6"
              title="주민등록 앞 6자리 입력"
              placeholder=""
              v-model="ssn"
              v-onlyNum
              v-skipOfMax
              nextTarget="ssnTwo"
            />
            <span class="sign" aria-hidden="true">-</span>
            <input type="tel" class="ipt" maxlength="1" id="ssnTwo" title="주민등록 뒤 1자리 입력" placeholder="" v-model="ssnTwo" v-onlyNum />
            <span class="sign" aria-hidden="true">******</span>
          </div>

          <!--<span class="label">생년월일</span>
          <ValidationProvider name="생년월일" rules="required|numeric|digits:4" v-slot="{ errors }">
            <div class="setBirth">
              <input type="tel" class="ipt notDel uiAct" maxlength="4" title="생년월일 년도 4자리" placeholder="1990" v-model="year" v-onlyNum />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" class="ipt notDel uiAct" maxlength="2" title="생년월일 월 2자리" placeholder="01" v-model="month" v-onlyNum />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" class="ipt notDel uiAct" maxlength="2" title="생년월일 일 2자리" placeholder="01" v-model="day" v-onlyNum />
            </div>
            <span>{{ errors[0] }}</span>
          </ValidationProvider>
          <span class="label">국적</span>
          <ul class="iptGroup iptBtn">
            <li>
              <input type="radio" class="ipt notDel uiAct" name="rdo1" id="rdo1_1" value="Y" checked="checked" v-model="localUserYn" />
              <label for="rdo1_1"><span class="ico">내국인</span></label>
            </li>
            <li>
              <input type="radio" class="ipt notDel uiAct" name="rdo1" id="rdo1_2" value="N" v-model="localUserYn" />
              <label for="rdo1_2"><span class="ico">외국인</span></label>
            </li>
          </ul>

          <span class="label">성별</span>
          <ul class="iptGroup iptBtn">
            <li>
              <input type="radio" class="ipt notDel uiAct" name="rdo2" id="rdo2_1" value="RCSB000M" checked="checked" v-model="sex" />
              <label for="rdo2_1"><span class="ico">남</span></label>
            </li>
            <li>
              <input type="radio" class="ipt notDel uiAct" name="rdo2" id="rdo2_2" value="RCSB000WM" v-model="sex" />
              <label for="rdo2_2"><span class="ico">여</span></label>
            </li>
          </ul>-->

          <span class="label">휴대폰번호</span>
          <div :class="'setAgency ' + [userIdentityCompTemp1 ? '' : 'selected']">
            <!-- 알뜰폰 선택 시 클래스추가 : selected -->
            <ul class="iptGroup iptBtn">
              <li>
                <input
                  type="radio"
                  class="ipt notDel uiAct"
                  name="rdosort"
                  id="agency_1"
                  value="MBCP0001"
                  checked="checked"
                  v-model="userIdentityCompTemp1"
                  @click="changeUserIdentityCompTemp1('MBCP0001')"
                />
                <label for="agency_1">SKT</label>
              </li>
              <li>
                <input
                  type="radio"
                  class="ipt notDel uiAct"
                  name="rdosort"
                  id="agency_2"
                  value="MBCP0002"
                  v-model="userIdentityCompTemp1"
                  @click="changeUserIdentityCompTemp1('MBCP0002')"
                />
                <label for="agency_2">KT</label>
              </li>
              <li>
                <input
                  type="radio"
                  class="ipt notDel uiAct"
                  name="rdosort"
                  id="agency_3"
                  value="MBCP0003"
                  v-model="userIdentityCompTemp1"
                  @click="changeUserIdentityCompTemp1('MBCP0003')"
                />
                <label for="agency_3">LGU+</label>
              </li>
            </ul>
            <div class="sltWrap">
              <select
                class="ipt notDel uiAct"
                id="agency_4"
                title="통신사 선택"
                v-model="userIdentityCompTemp2"
                @change="changeUserIdentityCompTemp2"
              >
                <option value="">알뜰폰</option>
                <option value="MBCP0005">SKT알뜰폰</option>
                <option value="MBCP0006">KT알뜰폰</option>
                <option value="MBCP0007">LGU+알뜰폰</option>
              </select>
            </div>
          </div>
          <ValidationProvider name="휴대폰 번호" rules="required|numeric" v-slot="{ errors }">
            <!--
            <div class="setPhone">
              <input
                type="tel"
                id="phone_2"
                class="ipt notDel uiAct"
                title="휴대폰 번호 입력"
                placeholder="' - ' 없이 입력해주세요."
                value=""
                v-model="cellNum"
                v-onlyNum
              />
              <button type="button" class="btn_s round s" @click="runCertification" v-show="!certificationFlag">
                {{buttonName}}
              </button>
            </div>
            -->

            <div class="setAddr uiAct">
              <div class="iptWrap">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt notDel uiAct"
                  title="휴대폰 번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="cellNum"
                  v-onlyNum
                />
              </div>
              <button type="button" class="btn_g m" @click="runCertification" v-if="!certificationFlag">{{ buttonName }}</button>
              <button type="button" class="btn_g m" style="opacity: 0.6" v-else>인증완료</button>
            </div>
          </ValidationProvider>

          <!--
          <div class="iptWrap addTxt" v-if="count > 0 && !certificationFlag">
            <ValidationProvider name="인증번호" rules="required" v-slot="{ errors }">
              <input
                type="tel"
                id="phone_3"
                class="ipt notDel uiAct"
                title="인증번호 입력"
                placeholder="인증번호 입력"
                maxlength="6"
                value=""
                v-model="authNum"
                v-onlyNum
              />
            </ValidationProvider>
            <span class="txt">
              유효시간
              <strong class="pointC1" v-text="timeLimit"></strong>
              &nbsp;
              <button type="button" class="btn_s round s" @click="checkCertification">
                인증
              </button>
            </span>
          </div>
          -->

          <ValidationProvider name="인증번호" rules="required" v-slot="{ errors }">
            <div class="setAddr uiAct" v-if="count > 0 && !certificationFlag">
              <div class="iptWrap addTxt">
                <input
                  type="tel"
                  id="phone_3"
                  class="ipt notDel uiAct"
                  title="휴대폰 번호 입력"
                  placeholder=""
                  value=""
                  v-model="authNum"
                  v-onlyNum
                />
                <span class="txt"><strong class="pointC1" v-text="timeLimit"></strong></span>
              </div>
              <button type="button" class="btn_g m" @click="checkCertification">인증번호확인</button>
            </div>
          </ValidationProvider>

          <div v-show="addr">
            <span class="label">거주지 주소</span>
            <div class="setAddr">
              <input
                type="tel"
                id="addr_1"
                class="ipt notDel uiAct"
                title="설치 주소 입력 (우편번호)"
                placeholder="우편번호"
                value="03142"
                readonly="readonly"
                v-model="addrPost"
              />
              <button type="button" class="btn_g m" @click="findAddr = true">우편번호찾기</button>
            </div>
            <ValidationProvider name="주소" rules="required" v-slot="{ errors }">
              <input
                type="text"
                id="addr_2"
                class="ipt"
                placeholder="기본주소"
                title="설치 주소 입력 (기본주소)"
                value="서울특별시 종로구 종로1길 50"
                readonly="readonly"
                v-model="addrRoad"
              />
            </ValidationProvider>
            <ValidationProvider name="상세주소" rules="required" v-slot="{ errors }">
              <input type="text" id="addr_3" class="ipt" placeholder="상세주소" title="설치 주소 입력 (상세주소)" v-model="addrRemark" />
              <!--<p class="txtList_remark">도서/산간 지역의 경우 추후 수령 시 추가 배송비가 과금될 수 있습니다.</p> -->
            </ValidationProvider>
          </div>

          <span class="singleIpt" v-show="addr">
            <input type="checkbox" class="ipt" name="otherAddr" id="otherAddr" v-model="otherAddr" />
            <label for="otherAddr">설치주소와 거주지가 다릅니다.</label>
          </span>

          <div v-show="otherAddr">
            <span class="label">설치/배송주소</span>
            <div class="setAddr">
              <input
                type="tel"
                id="addr_1"
                class="ipt"
                title="설치 주소 입력 (우편번호)"
                placeholder="우편번호"
                value=""
                readonly="readonly"
                v-model="installAddrPost"
              />
              <button type="button" class="btn_g m" @click="findAddr2 = true">우편번호찾기</button>
            </div>
            <input
              type="text"
              id="addr_2"
              class="ipt"
              placeholder="기본주소"
              title="설치 주소 입력 (기본주소)"
              value="서울특별시 종로구 종로1길 50"
              readonly="readonly"
              v-model="installAddrRoad"
            />
            <input type="text" id="addr_3" class="ipt" placeholder="상세주소" title="설치 주소 입력 (상세주소)" v-model="installAddrRemark" />
            <p class="txtList_remark">도서/산간 지역의 경우 추후 수령 시 추가 배송비가 과금될 수 있습니다.</p>
          </div>
        </div>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="goNextDepth" :disabled="!buttonCheck">다음</button>
        </div>
      </section>
      <FindAddr v-if="findAddr" @callback="selectAddr" @close="popupClose"></FindAddr>
      <FindAddr v-if="findAddr2" @callback="selectAddr2" @close="popupClose"></FindAddr>
      <MessagePop v-if="messagePop" @close="popupClose">
        <p v-html="popMsg"></p>
      </MessagePop>
      <ConfirmPop @close="close" @cancel="cancel" @confirm="confirm" v-if="confirmPop">
        <p v-html="popMsg"></p>
      </ConfirmPop>

      <!--<CommonPop v-if="openFlag" @close="popupClose" :popupFlags="popupFlag" :popCloseCallback="closeCallback" :popConfirmCallback="confirmCallback" :popCancelCallback="cancelCallback" :popAddrCallback="addrCallback" :popPageName="pageName" :webViewUrl="webView">
        <p v-html="msg"></p>
      </CommonPop>-->
    </div>
    <!-- content(e) -->
  </div>
</template>

<script>
//import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import FindAddr from '@/components/comm/FindAddr';
import MessagePop from '@/components/popup/MessagePop';
import ConfirmPop from '@/components/popup/ConfirmPop';

import { AUTH_TIMEOUT, AUTH_NOT_MATCH, INPUT_INFO_CHECK, GO_HOME } from '@/store/message.type.js'; //SUCCESS_CERTIFICATION
import { isEmpty } from '@/common/common.function';

export default {
  name: 'MemberStep1',
  components: {
    FindAddr,
    MessagePop,
    ConfirmPop,
  },
  // mixins: [popup],
  data: function () {
    return {
      // 로그인 정보
      userInfo: JwtService.getUserInfo(),

      paramObj: this.$route.params.paramObj,
      prodCode: this.$route.params.prodCode,
      couponId: this.$route.params.couponId,
      couponSerialNumber: this.$route.params.couponSerialNumber,

      // 입력 정보 관련
      customerName: null,
      localUserYn: 'Y',
      ssn: null,
      sex: null,
      userIdentityComp: 'MBCP0001',
      cellNum: null,
      ssnTwo: null,

      userIdentityCompTemp1: 'MBCP0001',
      userIdentityCompTemp2: '',
      fullSsn: null,

      // 주소 관련
      addrCode: null,
      addrPost: null,
      addrRoad: null,
      addrJibun: null,
      oriNadr1: null,
      oriNadr3: null,
      oriBld: null,
      addrRemark: null,
      otherAddr: false,
      installAddrCode: null,
      installAddrJibun: null,
      installAddrPost: null,
      installAddrRemark: null,
      installAddrRoad: null,
      installOriNadr1: null,
      installOriNadr3: null,
      installOriBld: null,

      addr: false,

      // 인증 관련
      timeLimit: '3:00',
      timeOver: null,
      authNum: null,
      certificationFlag: false,
      authParamObj: null,
      uniqueKey: null,
      countDown: null,
      count: 0,
      buttonName: '인증번호요청',
      buttonCheck: false, //버튼활성화여부

      // 팝업관련
      findAddr: null,
      webViewPop: null,
      messagePop: null,
      confirmPop: null,
      popMsg: null,
      findAddr2: null,
    };
  },
  created() {
    console.log('========================');
    console.log(this.paramObj);
    console.log(this.prodCode);
    console.log(this.couponId);
    console.log(this.couponSerialNumber);
  },
  mounted() {
    // 회원정보 세팅
    this.customerName = this.userInfo.userName;
    this.ssn = this.userInfo.birth;
    this.cellNum = this.userInfo.mobile;
    //document.getElementsByClassName('goTop')[0].remove();
  },
  watch: {
    addrRoad() {
      this.checkButton();
    },
    addrRemark() {
      this.checkButton();
    },
    installAddrPost() {
      this.checkButton();
    },
    installAddrRemark() {
      this.checkButton();
    },
    otherAddr() {
      this.checkButton();
      if (!this.otherAddr) {
        this.installAddrCode = '';
        this.installAddrPost = '';
        this.installAddrRoad = '';
        this.installAddrJibun = '';
        this.installOriNadr1 = '';
        this.installOriNadr3 = '';
        this.installOriBld = '';
        this.installAddrRemark = '';
      }
    },
  },
  methods: {
    checkButton: function () {
      let re = false;
      if (this.certificationFlag) {
        if (this.otherAddr) {
          if (
            !isEmpty(this.addrRoad) &&
            !isEmpty(this.addrRemark) &&
            !isEmpty(this.addrPost) &&
            !isEmpty(this.installAddrPost) &&
            !isEmpty(this.installAddrRemark)
          ) {
            re = true;
          }
        } else {
          if (!isEmpty(this.addrRoad) && !isEmpty(this.addrRemark) && !isEmpty(this.addrPost)) {
            re = true;
          }
        }
      }
      console.log(re);
      this.buttonCheck = re;
    },
    changeUserIdentityCompTemp1: function (value) {
      this.userIdentityCompTemp2 = '';
      this.userIdentityComp = value;
    },
    changeUserIdentityCompTemp2: function () {
      this.userIdentityCompTemp1 = '';
      this.userIdentityComp = this.userIdentityCompTemp2;
    },
    selectAddr: function (data) {
      this.addrCode = data.nnmb;
      this.addrPost = data.zip;
      this.addrRoad = data.nadr1;
      this.addrJibun = data.adr1;
      this.oriNadr1 = data.oriNadr1;
      this.oriNadr3 = data.oriNadr3;
      this.oriBld = data.oriBld;
      this.findAddr = false;

      const param = {
        nnmb: data.nnmb.toString(),
        nnmz: data.nnmz.toString(),
        addrRoad: data.nadr1,
        ordrNo: this.paramObj.request.orderCommInfo.orderId,
        // godsCrtnCd: this.color,
        prdtCd: this.paramObj.request.orderCommInfo.internalProdCode,
        addrPost: data.zip,
        plmkAddrGenMCntn: data.adr1,
        plmkAddrSpecMCntn: this.addrRemark,
        bldNmSCntn: data.oriBld,
        ldongCdCntn: data.ldongCdCntn,
      };
      ApiService.service('POST', '/common/address-save', param)
        .then((response) => {
          console.log(param);
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectAddr2: function (data) {
      //this.paramObj.request.orderCommInfo.orderId;
      //prodCode
      this.installAddrCode = data.nnmb;
      this.installAddrPost = data.zip;
      this.installAddrRoad = data.nadr1;
      this.installAddrJibun = data.adr1;
      this.installOriNadr1 = data.oriNadr1;
      this.installOriNadr3 = data.oriNadr3;
      this.installOriBld = data.oriBld;
      this.findAddr2 = false;

      const param = {
        nnmb: data.nnmb.toString(),
        nnmz: data.nnmz.toString(),
        addrRoad: data.nadr1,
        ordrNo: this.paramObj.request.orderCommInfo.orderId,
        // godsCrtnCd: this.color,
        prdtCd: this.paramObj.request.orderCommInfo.internalProdCode,
        addrPost: data.zip,
        plmkAddrGenMCntn: data.adr1,
        plmkAddrSpecMCntn: this.addrRemark,
        bldNmSCntn: data.oriBld,
        ldongCdCntn: data.ldongCdCntn,
      };
      ApiService.service('POST', '/common/address-save', param)
        .then((response) => {
          console.log(param);
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    goNextDepth: function () {
      // 입력 validation 체크
      let inputFlag = this.checkValidation();

      if (this.addrCode == null || this.addrCode == '') {
        inputFlag = true;
      }

      if (this.addrRemark == null || this.addrRemark == '') {
        inputFlag = true;
      }

      if (this.otherAddr && (this.installAddrCode == null || this.installAddrCode == '')) {
        inputFlag = true;
      }

      if (this.otherAddr && (this.installAddrRemark == null || this.installAddrRemark == '')) {
        inputFlag = true;
      }

      if (this.authNum == null || this.authNum == '') {
        inputFlag = true;
      }

      if (inputFlag) {
        this.popMsg = INPUT_INFO_CHECK;
        this.messagePop = true;
        return false;
      }

      if (!this.certificationFlag) {
        this.popMsg = INPUT_INFO_CHECK;
        this.messagePop = true;
        return false;
      }

      // 인증번호 시간 초과 체크
      if (this.timeOver == false) {
        this.popMsg = AUTH_TIMEOUT;
        this.messagePop = true;
        return false;
      }
      // 1 단계 저장
      let conOrderInfo = this.paramObj.request.conOrderInfo;
      conOrderInfo.cellNum = this.cellNum;
      conOrderInfo.conAddrCode = this.addrCode;
      conOrderInfo.conAddrJibun = this.addrJibun;
      conOrderInfo.conAddrPost = this.addrPost;
      conOrderInfo.conAddrRemark = this.addrRemark;
      conOrderInfo.conAddrRoad = this.addrRoad;
      conOrderInfo.oriNadr1 = this.oriNadr1;
      conOrderInfo.oriNadr3 = this.oriNadr3;
      conOrderInfo.oriBld = this.oriBld;

      conOrderInfo.customerName = this.customerName;
      conOrderInfo.ssn = this.fullSsn; // this.ssn;
      conOrderInfo.userIdentityComp = this.userIdentityComp;
      conOrderInfo.localUserYn = this.localUserYn;
      conOrderInfo.sex = this.sex;

      // 설치지역
      let installInfo = this.paramObj.request.installInfo;
      if (this.otherAddr) {
        installInfo.installAddrCode = this.installAddrCode;
        installInfo.installAddrJibun = this.installAddrJibun;
        installInfo.installAddrPost = this.installAddrPost;
        installInfo.installAddrRemark = this.installAddrRemark;
        installInfo.installAddrRoad = this.installAddrRoad;
        installInfo.oriNadr1 = this.installOriNadr1;
        installInfo.oriNadr3 = this.installOriNadr3;
        installInfo.oriBld = this.installOriBld;
      } else {
        installInfo.installAddrCode = this.addrCode;
        installInfo.installAddrJibun = this.addrJibun;
        installInfo.installAddrPost = this.addrPost;
        installInfo.installAddrRemark = this.addrRemark;
        installInfo.installAddrRoad = this.addrRoad;
        installInfo.oriNadr1 = this.oriNadr1;
        installInfo.oriNadr3 = this.oriNadr3;
        installInfo.oriBld = this.oriBld;
      }

      console.log(this.paramObj);
      if (JwtService.getMarParam() && JwtService.getMarParam != null) {
        this.paramObj.request.marParam = JwtService.getMarParam();
      }

      this.$refs.header.loadingStart(); // 로딩시작
      console.log(this.paramObj);
      console.log('this.couponSerialNumber ', this.couponSerialNumber);
      console.log('this.couponId ', this.couponId);
      ApiService.service('POST', '/order/rental', this.paramObj)
        .then(({ data }) => {
          if (data.isSucceed) {
            let creditParam = new Object();
            let creditRequest = new Object();
            creditRequest.orderId = this.paramObj.request.orderCommInfo.orderId;
            creditRequest.smsUniqueKey = this.uniqueKey;
            creditParam.request = creditRequest;
            creditParam.serviceType = 'app';

            ApiService.service('POST', '/order/credit', creditParam)
              .then(({ data }) => {
                if (data.isSucceed) {
                  this.paramObj.request.orderCommInfo.creditKey = data.result.resultData;
                  this.$router.push({
                    name: 'memberStep2',
                    params: {
                      paramObj: this.paramObj,
                      prodCode: this.prodCode,
                      couponId: this.couponId,
                      couponSerialNumber: this.couponSerialNumber,
                    },
                  });
                } else {
                  this.$router.push({ name: 'rentalFail' });
                }
              })
              .catch(({ response }) => {
                console.log('error : ' + response);
              });
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd(); // 로딩끝
        });

      // safeKey 키 발급
      /*let creditInfo = new Object();
        creditInfo.orderId = this.orderId;
        creditInfo.sendKey = 'Y';

        paramObj.request = creditInfo;

        ApiService.service('POST', '/external/credit/info', paramObj)
          .then(({ data }) => {
            //if (data.isSucceed) {
            // test 용
            if (data.result.resultCode == '0') {
              // 입력정보 세팅
              paramObj = new Object();
              let conInfo = new Object();
              let installInfo = new Object();

              paramObj.orderId = this.orderId;
              paramObj.prodCode = this.prodCode;

              conInfo.customerName = this.customerName;
              conInfo.ssn = this.ssn;
              conInfo.localUserYn = this.localUserYn;
              conInfo.sex = this.sex;
              conInfo.userIdentityComp = this.userIdentityComp;
              conInfo.cellNum = this.cellNum;

              installInfo.addrCode = this.addrCode;
              installInfo.addrPost = this.addrPost;
              installInfo.addrRoad = this.addrRoad;
              installInfo.addrJibun = this.addrJibun;
              installInfo.addrRemark = this.addrRemark;

              paramObj.conInfo = conInfo;
              paramObj.installInfo = installInfo;

              this.$router.push({
                name: 'memberStep2',
                params: { paramObj: paramObj },
              });
            } else {
              this.$router.push({ name: 'rentalReject' });
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });*/
    },
    runCertification: function () {
      if (this.checkValidation()) {
        this.popMsg = INPUT_INFO_CHECK;
        this.messagePop = true;
        return false;
      } else {
        var paramObj = new Object();
        var userInfo = new Object();
        userInfo.cellNum = this.cellNum;
        userInfo.customerName = this.customerName;
        userInfo.localUserYn = this.localUserYn;

        if (this.sex == 'RCSB000M') {
          userInfo.sex = '1';
        } else if (this.sex == 'RCSB00WM') {
          userInfo.sex = '2';
        }

        if (this.ssnTwo == '1' || this.ssnTwo == '2' || this.ssnTwo == '5' || this.ssnTwo == '6') {
          userInfo.ssn = '19' + this.ssn;
        } else if (this.ssnTwo == '3' || this.ssnTwo == '4' || this.ssnTwo == '7' || this.ssnTwo == '8') {
          userInfo.ssn = '20' + this.ssn;
        }
        this.fullSsn = userInfo.ssn;

        console.log('aaaaa :: ' + this.userIdentityComp);
        userInfo.userIdentityComp = this.userIdentityComp.substring(this.userIdentityComp.length - 1);
        console.log('userInfo.userIdentityComp > ' + this.userIdentityComp.substring(this.userIdentityComp.length - 1));
        paramObj.request = userInfo;
        paramObj.serviceType = 'app';

        //////////////////////////  중복체크단
        let duplParam = {
          request: {
            orderId: this.paramObj.request.orderCommInfo.orderId,
            name: this.customerName,
            mobile: this.cellNum,
            internalProdCode: this.paramObj.request.orderCommInfo.internalProdCode,
          },
          serviceType: 'app',
        };

        ApiService.service('POST', '/order/id/duplicate', duplParam)
          .then(({ data }) => {
            if (data.isSucceed) {
              if (data.result != '' && data.result != undefined) {
                //this.paramObj.request.orderCommInfo.orderId = data.result;

                this.paramObj.request.orderCommInfo.orderId = data.result.orderId;
                this.paramObj.request.orderCommInfo.convertedYn = data.result.convertedYn;
                this.paramObj.request.orderCommInfo.convertedYnApp = data.result.convertedYnApp;
              }
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
        //////////////////////////  중복체크 완료

        ApiService.service('POST', '/external/verification', paramObj)
          .then(({ data }) => {
            if (data.isSucceed) {
              this.uniqueKey = data.result.uniqueKey;
              this.paramObj.request.orderCommInfo.requestKey = data.result.uniqueKey;
              this.popMsg = '인증번호가 발송되었습니다.';
              this.messagePop = true;
              this.buttonName = '재요청';

              // 인증번호 시간 유효 시간
              clearInterval(this.countDown);
              this.count = 180;
              this.timeOver = null;

              this.countDown = setInterval(() => {
                this.count--;

                let minutes = Math.floor(this.count / 60);
                let seconds = this.count % 60 < 10 ? '0' + (this.count % 60) : this.count % 60;

                this.timeLimit = minutes + ' : ' + seconds;

                if (this.count == 0) {
                  clearInterval(this.countDown);
                  this.timeOver = false;
                  this.buttonName = '인증번호요청';
                  this.timeLimit = '3:00';
                  this.popMsg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
                  this.messagePop = true;
                }
              }, 1000);
            } else {
              this.popMsg = data.error;
              this.messagePop = true;
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    checkValidation: function () {
      let inputFlag = false;

      if (this.customerName == null || this.customerName == '') {
        inputFlag = true;
      }

      if (this.ssn == null || this.ssn == '') {
        inputFlag = true;
      }

      if (this.ssnTwo == null || this.ssnTwo == '') {
        inputFlag = true;
      }

      if (this.userIdentityComp == null || this.userIdentityComp == '') {
        inputFlag = true;
      }

      if (this.cellNum == null || this.cellNum == '') {
        inputFlag = true;
      }

      // 성별 및 내 외국인 여부 체크
      if (Number(this.ssnTwo) % 2 == 1) {
        this.sex = 'RCSB000M';
      } else {
        this.sex = 'RCSB00WM';
      }

      if (this.ssnTwo == '1' || this.ssnTwo == '2' || this.ssnTwo == '3' || this.ssnTwo == '4') {
        this.localUserYn = 'Y';
      } else {
        this.localUserYn = 'N';
      }

      return inputFlag;
    },
    rental: function () {
      //장바구니에 담을건지 ConfirmPop 노출
      this.popMsg = GO_HOME;
      this.confirmPop = true;
      console.log('메세지alert');
    },
    cancel: function () {
      console.log('X버튼');
      this.confirmPop = false;
    },
    close: function () {
      this.confirmPop = false;
    },
    confirm: function () {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.replace('/');
    },
    popupClose: function () {
      console.log('???');
      this.findAddr = null;
      this.findAddr2 = null;
      this.messagePop = null;
      this.confirmPop = null;
    },
    checkCertification: function () {
      if (this.authNum == null || this.authNum == '') {
        this.msg = '';
        this.messagePop = true;
      }

      if (this.timeOver == false) {
        this.popMsg = AUTH_TIMEOUT;
        this.messagePop = true;
        return false;
      }

      // 인증번호 확인
      var paramObj2 = new Object();
      var userInfo = new Object();
      userInfo.orderId = this.paramObj.request.orderCommInfo.orderId;
      userInfo.authNum = this.authNum;
      userInfo.uniqueKey = this.uniqueKey;

      paramObj2.request = userInfo;
      paramObj2.serviceType = 'app';

      ApiService.service('PUT', '/external/verification', paramObj2)
        .then(({ data }) => {
          if (!data.isSucceed) {
            this.popMsg = AUTH_NOT_MATCH;
            this.messagePop = true;
            return false;
          } else {
            this.certificationFlag = true;
            clearInterval(this.countDown);
            document.getElementById('phone_2').disabled = true;
            // 1 단계 저장
            let conOrderInfo = this.paramObj.request.conOrderInfo;
            conOrderInfo.cellNum = this.cellNum;
            conOrderInfo.customerName = this.customerName;
            conOrderInfo.ssn = this.fullSsn; //this.ssn;
            conOrderInfo.localUserYn = this.localUserYn;
            conOrderInfo.sex = this.sex;

            if (this.uniqueKey.substring(0, 1) != this.userIdentityComp.substring(7)) {
              console.log('in');
              this.userIdentityComp = this.userIdentityComp.substring(0, 7) + this.uniqueKey.substring(0, 1);
              console.log('this.userIdentityComp >> ' + this.userIdentityComp);
            }
            conOrderInfo.userIdentityComp = this.userIdentityComp;

            //alert(JSON.stringify(this.paramObj));

            ApiService.service('POST', '/order/rental', this.paramObj)
              .then(({ data }) => {
                if (data.isSucceed) {
                  //this.popMsg = SUCCESS_CERTIFICATION;
                  //this.messagePop = true;
                  this.paramObj.request.orderCommInfo.safekey = data.result.resultData;
                  this.addr = true;
                  const params = {
                    af_content_id: this.paramObj.prodCode,
                    af_method: '회원',
                  };

                  window.appsFlyer('af_rental_verification', params);
                } else {
                  this.authNum = null;
                  this.popMsg = data.error;
                  this.messagePop = true;
                }
              })
              .catch(({ response }) => {
                console.log('error : ' + response);
              });
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
  },
};
</script>
